module.exports = __webpack_public_path__ + "static/media/icon_error.23cc7d0f.svg";